var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamworkCollaboration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_73",
    "data-name": "Group 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 75.08,
    viewBox: "0 0 85 75.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 85,
    height: 75.08,
    fill: "#dd4633"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M97.972,12.3a12.535,12.535,0,0,1,1.966-.657,4.958,4.958,0,0,1,5.279,6.633c-.532,1.669-2.357,2.641-3.349,4.017.544-.084.966-.457,1.514-.6a4.961,4.961,0,0,1,6.03,6.2c-.543,1.973-2.48,3.026-3.649,4.564a17.245,17.245,0,0,1,1.823-.632,4.975,4.975,0,0,1,4.448,8.344c-5.043,4.522-9.577,10.242-14.651,14.652A13.2,13.2,0,0,1,87.218,58.2c-2.221-.131-3.556-.8-5.881-.119-2.894.853-4.468,3.858-6.8,5.529l-20.6-20.651c.651.279,1.121.712,1.819.974a6.766,6.766,0,0,0,9.147-5c.075-.407-.066-1.308.2-1.492a6.913,6.913,0,0,0,6.955-7.019A6.8,6.8,0,0,0,79,23.306c6.171.258,9.079-6.777,5.269-11.408l7.549-7.532C97.4.424,102.845,7.683,97.972,12.3",
    transform: "translate(-41.753 -2.504)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M72.148,11.516a5.036,5.036,0,0,1-5.268,7.553,11.466,11.466,0,0,1-1.989-.8,4.972,4.972,0,0,1-4.982,7.775c-.673-.093-1.157-.537-1.793-.662a5.2,5.2,0,0,1-1.182,6.694c-1.845,1.434-3.945,1.244-5.932.251a5.013,5.013,0,0,1-5.754,7.531c-1.51-.512-5.282-4.236-5.773-5.745a4.989,4.989,0,0,1,.767-4.671c1.663-2.164,4.361-2.362,6.695-1.183-1.48-1.933-4.023-3.164-4.24-5.836-.346-4.262,3.464-6.646,7.289-5-4.264-4.426.133-10.752,5.759-8.3-5.3-4.754.987-12.272,6.424-7.688a4.787,4.787,0,0,0-.021,4.252A22.6,22.6,0,0,0,67.594,10.9a8.134,8.134,0,0,0,4.553.615",
    transform: "translate(-30.352 0)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M8.913,181.328a1.606,1.606,0,0,1,1.576.385l21.379,21.473a1.8,1.8,0,0,1-.38,1.9l-8,7.918a1.862,1.862,0,0,1-1.993-.292L.194,191.332A1.494,1.494,0,0,1,.4,189.586a88.963,88.963,0,0,1,7.88-7.873,1.584,1.584,0,0,1,.632-.385",
    transform: "translate(0 -140.333)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M257.006,191.124a1.394,1.394,0,0,1,1.314.3c2.2,2.66,5.733,5.125,7.8,7.788.427.551.784,1.094.431,1.795l-21.513,21.678a1.714,1.714,0,0,1-1.826.112l-8.008-7.913a1.66,1.66,0,0,1,.08-2.459l20.664-20.665a2.572,2.572,0,0,1,1.062-.637m-13.214,19.313c-3.015.561-2.931,5.414.3,5.719,4.628.437,4.221-6.56-.3-5.719",
    transform: "translate(-181.69 -147.926)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M205.432,195.106a14.973,14.973,0,0,0,9.3-2.98l14.689-14.455,2.6,2.444-20.769,20.737Z",
    transform: "translate(-159.037 -137.545)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M149.313,3.864a66.861,66.861,0,0,1,9.94-.025A2.268,2.268,0,0,1,161,5.1l-7.628,7.5a5.916,5.916,0,0,1-2.4-1.152,23.47,23.47,0,0,1-3.456-3.659,2.72,2.72,0,0,1,1.8-3.92",
    transform: "translate(-113.973 -2.839)",
    fill: "#dd4633"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamworkCollaboration);
export default __webpack_public_path__ + "static/media/teamwork_collaboration.1879690a4d9555e951f6c34dc674474b.svg";
export { ForwardRef as ReactComponent };